/**
 * Created by zhj on 3/28/2016.
 */
'use strict';

angular.module('dashboard.vehiclesList', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('vehiclesListWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.vehiclesListWidget.title';
          },
          description: function () {
            return 'dashBoard.fleetManagement.vehiclesListWidget.description';
          }
        },
        controller: 'vehiclesListCtrl',
        templateUrl: 'components/dashboard/vehicles/vehiclesListWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          statusCodeList: [],
          vehicleList: [],
          vehicleGroup: null,
          vehicleGroupList: [],
          statusCode: null,
          noOfGridRows: 10
        },
        edit: {
          templateUrl: 'components/dashboard/vehicles/vehiclesListEdit.tpl.html',
          reload: false,
          controller: 'vehiclesListEditCtrl'
        }
      });
  }).service('vehiclesListService', function (crudService) {
  var selectedRow = {};
  this.getVehicleList = function (vehicleGroup, dataRefresh) {
    var requestParam = {
      statusCode: 'all',
      vehicleGroup: vehicleGroup,
      dataRefresh: dataRefresh,
      reportName: 'DeviceCommandDashboardInfo',
      timeTo: '-0d',
      timeFrom: ''
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('portalcommands', 'vehiclelist', param);
  };

  this.setSelectedRow = function (row) {
    selectedRow = row;
  };
  this.getSelectedRow = function () {
    return selectedRow;
  };
}).controller('vehiclesListCtrl', function ($scope, widgetSettingsCreatorService, commonTrackService, config, vehiclesListService, $timeout, $rootScope, $translate, vehicleListWidgetService, localStorageService, AuthenticationService, $state, errorHandlingService, $interval) {

  $scope.isDataAvailable = true;
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  var counterSeconds = 60;
  var counterTimeout;
  var broadcastEventData = {
    selectedRow: {},
    selectedVehicleGroup: '',
    selectedStatusCode: '',
    selectedVehicleGroupLabel: '',
    eventSource: ''
  };
  var contextMenu = {};

  $scope.startCounter = function () {
    $scope.stop();
    $scope.isTimerStated = true;
    $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
    if ($scope.counter - 1 >= 1) {
      $scope.counter--;
      counterTimeout = $interval($scope.startCounter, 1000);
    } else {
      loadVehicleList(config.vehicleGroup, true);
    }

  };

  $scope.stop = function () {
    $interval.cancel(counterTimeout);
  };
  var rowSize = vehicleListWidgetService.getRowSize();
  $scope.customGridProperties = {
    height: config.noOfGridRows ? rowSize[config.noOfGridRows] - 15 : 455,
    pageable: false,
    columns: []
  };

  $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID'
  });

  $scope.vehicleGroupComboChange = function (event) {
    var vehicleGroup = event.args.item;
    if (vehicleGroup) {
      if (config.vehicleGroup !== vehicleGroup.value || $scope.createVehiclesListGrid) {
        loadVehicleList(vehicleGroup.value, true);
      }
      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, vehicleGroup.value);
      config.vehicleGroup = vehicleGroup.value;

    }
  };

  $scope.vehiclesListRowSelectHandler = function (event) {
    if (event.type === 'rowselect' && event.args.row) {
      broadcastEventData.selectedRow = event.args.row;
      broadcastEventData.selectedRow.jobstatuscode = broadcastEventData.selectedRow.jobstatuscode;
      vehiclesListService.setSelectedRow(event.args.row);
      $rootScope.$broadcast('vehiclesListRowSelected', broadcastEventData);

      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('selected_vehicle.' + loginid.Account + '.' + loginid.username, {
        'deviceid': broadcastEventData.selectedRow.deviceid,
        'driverid': broadcastEventData.selectedRow.driverid
      });

    }
  };

  function createMessageEvent() {
    $rootScope.$broadcast('newMsgEvent', {});
  }

  function createCommandEvent() {
    $rootScope.$broadcast('newCommandEvent', {});
  }

  function showDashboard() {
    $state.go('betotrack.dashboard');
  }

  function showDriverDashboard() {
    $state.go('driverdashboard');
  }

  function showFmsDashboard() {
    $state.go('fmsdashboard');
  }

  var _contextSourceObj = {
    portalCommandCtxSource: [
      {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
        execute: createMessageEvent
      },
      {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
        execute: createCommandEvent
      },
      {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
        execute: showDashboard
      }, {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
        execute: showDriverDashboard
      }, {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
        execute: showFmsDashboard
      }
    ]
  };

  $scope.gridRowClickHandler = function (event) {
    if (event.args.rightclick) {
      commonTrackService.initGridRightClickContextMenu(event, contextMenu);
    }
  };

  $scope.portalCommandContextHandler = function (event) {
    commonTrackService.executeContextMenuClick(event, 'portalCommandCtxSource', _contextSourceObj);
  };

  var loadVehicleGroup = function () {
    return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
      if (vechileGroupList.length > 0) {
        $scope.vehicleGroupSettings.source = vechileGroupList;
        config.vehicleGroupList = vechileGroupList;


        var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

        if(commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)){ // validate the local storage group is still valid ( group can change based on login )
          $scope.vehicleGroup = config.vehicleGroup;
        }

        if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
          if(commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)){// validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = cachedGroup;
            config.vehicleGroup = cachedGroup;
          }
        }

        if(!$scope.vehicleGroup ){
          $scope.vehicleGroup = vechileGroupList[0].groupID;
        }
      }
    });
  };

  var loadOverviewListSettings = function () {
    return commonTrackService.getOverviewListSettings('vehiclelists').then(function (overviewListSetting) {
      $scope.columnPropertiesList = overviewListSetting.overviewListGrids[0].columnProperties;
    });
  };
  var pendingCommandsVehicleListSource =
    {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };

  var loadVehicleList = function (vehicleGroup, dataRefresh) {
    $scope.stop();
    return vehiclesListService.getVehicleList(vehicleGroup, dataRefresh).then(function (vehicleResult) {
      if (vehicleResult) {
        var dataSource;
        if (vehicleResult.dataList) {
          $scope.translationMap = vehicleResult.columnTranslation;
          $scope.customGridProperties.columns = commonTrackService.getColumnProperties($scope.columnPropertiesList, $scope.translationMap, {moduleName: 'vehicles'});
          var _additionalProperties = {translatedName: $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title')};
          $scope.vehiclesListSettings = commonTrackService.getGridSettings('vehicles', $scope.customGridProperties, null, _additionalProperties);
          pendingCommandsVehicleListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'vehiclesList', pendingCommandsVehicleListSource);
          $scope.vehiclesListdataAdapter = new $.jqx.dataAdapter(pendingCommandsVehicleListSource);
        }
        dataSource = vehicleResult.dataList;
        $scope.isDataAvailable = true;

        commonTrackService.rebuildDataSource($scope.columnPropertiesList, $scope.translationMap, dataSource);
        pendingCommandsVehicleListSource.localdata = dataSource;
        $scope.vehiclesListSettings.source = $scope.vehiclesListdataAdapter;
        commonTrackService.updateBoundData($scope.overviewGridPrefix + 'vehiclesList');
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      $scope.counter = counterSeconds;
      if (($scope.isDataAvailable && !counterTimeout) || (counterTimeout.$$state && counterTimeout.$$state.value === 'canceled' && $scope.isDataAvailable)) {
        $scope.startCounter();
      } else {
        $scope.stop();
      }


      $timeout(function () {
        var rows = $('#' + $scope.overviewGridPrefix + 'vehiclesList').jqxGrid('getrows');
        var _lastLocSelectedRowIndex = commonTrackService.getSelectRowIndexByCache(rows);
        if (_lastLocSelectedRowIndex < 0) {
          broadcastEventData.selectedRow = null;
          $rootScope.$broadcast('vehiclesListRowSelected', broadcastEventData);
          return;
        } else {
          $('#' + $scope.overviewGridPrefix + 'vehiclesList').jqxGrid('selectrow', _lastLocSelectedRowIndex);
        }
      }, 0);
      if ($scope.createVehiclesListGrid) {
        $rootScope.$broadcast('pendingDashboardVehiclesRefreshed');
      }
      $scope.createVehiclesListGrid = true;
    });
  };

  loadVehicleGroup().then(function () {
    loadOverviewListSettings();
  }).finally(function () {
    $scope.dataLoadingFinished = true;
    if ($scope.vehicleGroup) {
      loadVehicleList($scope.vehicleGroup, true);
    }
    $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(165);
    $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
      created: function (args) {
        contextMenu = args.instance;
      }, source: _contextSourceObj.portalCommandCtxSource
    });
  });
  $scope.stopAutoRefresh = commonTrackService.getRefreshStartStopfunction($scope, false, false, loadVehicleList, 'vehicleGroupComboBox', true);
  $scope.$on('$destroy', function () {
    $scope.stop();
    if ($scope.vehiclesListSettings && $scope.vehiclesListSettings.source) {
      delete  $scope.vehiclesListSettings.source;
    }
    if ($scope.vehiclesListdataAdapter) {
      delete $scope.vehiclesListdataAdapter;
    }
  });
}).controller('vehiclesListEditCtrl', function ($scope, config, $translate, widgetSettingsCreatorService) {
  $scope.noOfGridRows = config.noOfGridRows;
  var source = [
    '5', '10', '15', '25', '50', '75', '100'
  ];

  // init DropDownList's settings object.
  $scope.noOfRowsettings =
    {
      placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
      width: 200, height: 25,
      autoDropDownHeight: true,
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
      source: source
    };

  $scope.noOfGridOnChange = function (event) {
    config.noOfGridRows = event.args.item.value;
  };
});



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicles/vehiclesListWidget.js